import React from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  const handleLinkClick = (e, path) => {
    e.preventDefault();
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <Navbar bg="light" variant="light" className="footer mt-auto" expand="lg">
      <Container>
        <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center w-100 gap-2 gap-lg-3">
          <Navbar.Brand className="footer-brand mb-0 order-1 order-lg-0">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="footer-nav" className="d-lg-none order-0" />
          <Navbar.Collapse id="footer-nav" className="order-2 order-lg-1">
            <Nav className="d-flex flex-row gap-2 justify-content-center">
              <Nav.Link 
                href="/pricing" 
                onClick={(e) => handleLinkClick(e, '/pricing')}
                className="px-2"
              >
                {t('footer.pricing')}
              </Nav.Link>
              <span className="text-muted d-none d-sm-inline">|</span>
              <Nav.Link 
                href="/offer" 
                onClick={(e) => handleLinkClick(e, '/offer')}
                className="px-2"
              >
                {t('footer.offer')}
              </Nav.Link>
              <span className="text-muted d-none d-sm-inline">|</span>
              <Nav.Link 
                href="/landing" 
                onClick={(e) => handleLinkClick(e, '/landing')}
                className="px-2"
              >
                {t('footer.aboutProject')}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Container>
    </Navbar>
  );
};

export default Footer;

